module.exports = __webpack_public_path__ + "img/FewClouds.ffeb0d80.png";